import { fetchToken } from "../../../common/FetchCookie";
import { Unlock_Candidate } from "../../../common/URLs";

export const UnlockCandidate = async (uuid) => {
    try {
        const token = await fetchToken();
        
        // Check the URL format - this might be the issue
        // console.log("Calling API with URL:", `${Unlock_Candidate}${uuid}`);
        
        // Modify this line based on your backend API format
        // Option 1: If your endpoint expects a path parameter
        const response = await fetch(`${Unlock_Candidate}/${uuid}`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        
        // Option 2: If your endpoint expects the UUID in the request body
        // const response = await fetch(`${Unlock_Candidate}`, {
        //     method: "POST",
        //     headers: {
        //         Authorization: `Bearer ${token}`,
        //         "Content-Type": "application/json"
        //     },
        //     body: JSON.stringify({ uuid })
        // });

        // console.log("API Response status:", response.status);
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            console.error("Error response:", errorData);
            throw new Error(`Failed with status ${response.status}`);
        }
        
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("UnlockCandidate API error:", error);
        throw error;
    }
};